// extracted by mini-css-extract-plugin
export var button = "Slider-module--button--17caa";
export var container = "Slider-module--container--e7791";
export var content = "Slider-module--content--4df20";
export var icon = "Slider-module--icon--b5181";
export var showStepper = "Slider-module--showStepper--f31ec";
export var stepper = "Slider-module--stepper--45e5c";